exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3GAq {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n._1ax9 {\n    opacity: 0;\n}\n\n._3y0d {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    position: absolute;\n    height: 50%;\n    margin: 0;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0);\n    opacity: 0;\n}\n\n._2PXD {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 1;\n}\n\n._3y0d svg {\n    margin: 0;\n    max-height: 100%;\n    width: 1.3em;\n    height: 1.3em;\n}\n", ""]);

// exports
exports.locals = {
	"innerText": "_3GAq",
	"innerTextLoading": "_1ax9",
	"loader": "_3y0d",
	"loaderVisible": "_2PXD"
};